import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { EscalarPanel } from './EscalarPanel';

export type EscalarScopeType = 'queue' | 'service' | 'bulk' | 'reset';

export interface EscalarItem {
  id: string;
  name: string;
  currentReplicas: number;
}

export interface EscalarScope {
  type: EscalarScopeType;
  cluster: string;
  items: EscalarItem[];
}

export interface EscalarModalProps {
  open: boolean;
  onClose: () => void;
  scope: EscalarScope;
}

export function EscalarModal({ open, onClose, scope }: EscalarModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  if (typeof document === 'undefined') return null;

  const handleBackdropClick = (e: React.MouseEvent): void => {
    if (e.target === e.currentTarget) onClose();
  };

  const body = (
    <div
      data-testid="escalar-modal-backdrop"
      onClick={handleBackdropClick}
      className="fixed inset-0 bg-primary/30 backdrop-blur z-50"
    >
      <EscalarPanel scope={scope} onClose={onClose} />
    </div>
  );

  return createPortal(body, document.body);
}

EscalarModal.displayName = 'EscalarModal';

export default EscalarModal;
